import React from 'react';
import {
  Tooltip,
  OverlayTrigger,
  Col,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import FaTimesCircle from 'react-icons/lib/fa/times-circle';

const tooltipAnswerReduceConditionRule = (
  <Tooltip className="in" id="tooltip-top">
    From 0 to 100. Item is donated if 100 points is set.
  </Tooltip>
);

const QualityCheckAnswerEdit = (props) => {
  const { currentAnswer } = props;
  const {AnswerCustomData = {}} = currentAnswer;
  return (
    <div className="bot15 bot10">
      <Col xs={12} className="bot10 pleft0">
        <FormControl
          type="text"
          style={{ width: 250, float: 'left' }}
          onChange={({ target: { value } }) => {
            if(value.length > 70) {
              return props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Answer text can not be longer than 70 characters',
              });
          }

            props.updateAnswerField('AnswerText', value);
          }}
          value={currentAnswer.AnswerText}
          placeholder="Answer Text"
        />
        <ControlLabel
          className="left15"
          style={{ marginTop: 5, float: 'left' }}
        >
          Reduce condition by:
        </ControlLabel>
        <OverlayTrigger
          placement="top"
          overlay={tooltipAnswerReduceConditionRule}
        >
          <FormControl
            type="number"
            className="left15 with-custom-arrows"
            style={{ width: 80, float: 'left' }}
            min="1"
            max="100"
            onChange={({ target: { value } }) =>  {
                props.updateAnswerField('Penalty', value);
            }}
            value={currentAnswer.Penalty || ''}
            placeholder=""
          />
        </OverlayTrigger>
        <FaTimesCircle
          style={{ marginTop: 6, float: 'left'  }}
          className="deleteButton left15"
          onClick={() => props.deleteAnswer()}
        ></FaTimesCircle>
      </Col>
      {(currentAnswer.NextQC || AnswerCustomData.PartnerNextQC) &&
        <Col xs={12} className="bot10 pleft0">
          {currentAnswer.NextQC &&
            <div>{`Next : ${currentAnswer.NextQC}`}</div>
          }
          {AnswerCustomData.PartnerNextQC &&
            <div>{`Next for 3PL seller, pallet or GBG Inventory: ${AnswerCustomData.PartnerNextQC}`}</div>
          }
        </Col>
      }
    </div>
  );
};

export default QualityCheckAnswerEdit;
